module.exports = __webpack_public_path__ + "img/電気回路_4_7_5.87401586.png";